import React from 'react';

import { Icon } from 'components';

import { getColorNavigateItem, NavigateItem } from 'entities/application';

import {
  useApplicationOperations,
  useActiveMenuItems
} from 'entities/application';
import { useFavouriteStationsButtonText } from '../../hooks';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { MENU_ITEMS } from 'entities/application';
import { BUTTON_ICON, FAVOURITE_STATIONS_BUTTON_ID } from '../../constants';

export const FavouriteStationsDesktopButton = () => {
  const favouriteStationsButtonText = useFavouriteStationsButtonText();
  const { setActiveMenuItem } = useApplicationOperations();
  const activeMenuItems = useActiveMenuItems();

  return (
    <NavigateItem
      icon={
        <Icon
          kind={BUTTON_ICON}
          style={{ color: getColorNavigateItem(activeMenuItems.favouriteStations) }}
        />}
      title={favouriteStationsButtonText}
      selected={activeMenuItems.favouriteStations}
      onClick={() => {
        setActiveMenuItem(MENU_ITEMS.favouriteStations);
        logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.openFavouriteServicePoints);
      }}
      id={FAVOURITE_STATIONS_BUTTON_ID}
    />
  );
};
